export default {
  field: {
    location_1: "苗栗獅潭",
    name_1: "紙湖農場",
    address_1: "354苗栗縣獅潭鄉苗栗縣獅潭鄉百壽村18號",

    location_2: "桃園龍潭",
    name_2: "桃園客家文化館",
    address_2: "325桃園市龍潭區中正路三林段500號",

    location_3: "新竹峨眉",
    name_3: "歇心茶楼",
    address_3: "315新竹縣峨眉鄉60-8",

    location_4: "新竹峨眉",
    name_4: "十二寮レジャー農業園区",
    address_4: "315新竹縣峨眉鄉13鄰21號",

    location_5: "苗栗公館",
    name_5: "油桐花坊",
    address_5: "363苗栗縣公館鄉福德村打鹿坑福德35之3號",

    location_6: "苗栗三義",
    name_6: "卓也コテージ",
    address_6: "367苗栗縣三義鄉雙潭村崩山下1-9號",

    location_7: "台中東勢",
    name_7: "東勢客家文化園区",
    address_7: "423台中市東勢區中山路1號",

    location_8: "彰化芬園",
    name_8: "古生物ファンタジーランド",
    address_8: "502彰化縣芬園鄉中山路167號",

    location_9: "南投埔里",
    name_9: "牛耳芸術リゾート村",
    address_9: "545南投縣埔里鎮中山路四段1號",

    location_10: "苗栗銅鑼",
    name_10: "桐花ロハス公園",
    address_10: "366苗栗縣銅鑼鄉龍泉15號",

    location_11: "新竹新埔",
    name_11: "新埔森Villa",
    address_11: "305新竹縣新埔鎮新龍路 752巷38號",

    location_12: "苗栗頭屋",
    name_12: "魯冰花レジャー農場",
    address_12: "362苗栗縣頭屋鄉明德村仁隆21號",

    location_13: "苗栗通霄",
    name_13: "上田コーヒーレジャー農園",
    address_13: "35750苗栗縣通霄鎮九鄰93-1號",

    location_14: "新竹關西",
    name_14: "馬武督森林探索",
    address_14: "306新竹縣關西鎮12鄰138-3號",

    location_15: "台東鹿野",
    name_15: "旧鉄道キンカ步道",
    address_15: "",

    location_16: "苗栗銅鑼",
    name_16: "台湾客家文化館",
    address_16: "366003苗栗縣銅鑼鄉銅科南路6號",

    location_17: "苗栗造橋",
    name_17: "剣潭古道",
    address_17: "",

    location_18: "嘉義市",
    name_18: "幸福山丘",
    address_18: "600嘉義市東區東義路566巷52-1號",

    location_19: "花蓮吉安",
    name_19: "南華林業園区",
    address_19: "973花蓮縣吉安鄉吉安路六段117號",

    location_20: "新竹橫山",
    name_20: "大山北月",
    address_20: "312新竹縣橫山鄉大山背80號"
  },

  menu: {
    language: "言語",
    flowering_map: "開花マップ",
    main_platform_name: "客庄小旅行",
    header_platform_name: "{year_en}年桐の開花状況予測",
    platform_name: "桐の花開花状況予測平台",
    // banner_description: "{year_en}年桐の開花状況&開花状況予測 ({year_en}年4月1日より、開花予測を更新します)",
    banner_description: "{year_en}年桐の開花状況&開花状況予測(見頃は終了しました)",
    go_to_top: "TOP",

    north: "北部エリア",
    central: "中部エリア",
    south: "南部エリア",
    east: "東部エリア",

    stage_bud: "つぼみ期",
    stage_flowering: "開花",
    stage_blossoming: "満開",
    stage_wither: "見頃終盤",
    map_of_taiwan: "台湾地図",
    data_source: "資料出典",
    CWB_stations: "中央気象局",
    CWB_forecast: "中央気象局週間天気予報",
    forecast: "週間天気",
    uv_info: "紫外線",
    realtime_data: "最新データ",
    updated_at: "最新アップデート",
    line_group: "LINEグループ「お花見リアルタイム情報」",
    join_line_group_description: "LINEグループ参加で最新のお花見情報get",
    line_group_button_for_phone: "ここをタップして参加",
    traffic: "交通情報",
    info_description:
      "桐の花の開花予想は実際の気象環境に基づくデータではなく、環境の実地観測データと例年の開花時期に基づき作られた予測モデルによる予想です。開花状況は臨機応変に更新します",
    info_description2: "2023年桃園、新竹、苗栗、台中、彰化、南投、嘉義、花蓮、台東9県/市は20の観測設備を設置。",
    info_update: "最終更新日",
    info_source:
      'データは<a href="https://www.hakka.gov.tw" target="blank">客家委員会</a>、<a href="https://www.agriweather.online" target="blank">AgriWeather</a>による共同開発及び提供',
    recommand_link:
      'おすすめサイト：<a href="https://www.cwa.gov.tw/V8/C/L/Hakka/index.html" target="blank">中央気象局</a>、<a href="https://recreation.forest.gov.tw" target="blank">台湾森林レクリエーションサイト</a>'
  },

  sensor: {
    air_temperature: "大気温",
    u_air_temperature: "℃",
    air_humidity: "空気湿度",
    u_air_humidity: "%",

    rainfalls: "累積降雨量 (24 hour)",
    u_rainfalls: "mm",
    rain_rate: "降雨率",
    u_rain_rate: "mm/hr",
    wind_speed: "風速",
    u_wind_speed: "m/s",
    solar_radiation: "日照",
    u_solar_radiation: "W/m<sup>2</sup>"
  }
};
